import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '~/lib/api';
import type { DevLoginInput } from '~shared/schemas';

/** Вход участника (participant-auth): конфиг способов входа, текущий участник, выход, dev-вход. */

export const AUTH_KEYS = {
  config: ['auth', 'config'] as const,
  me: ['auth', 'me'] as const,
};

export function useAuthConfig() {
  return useQuery({ queryKey: AUTH_KEYS.config, queryFn: api.auth.config, staleTime: Infinity });
}

export function useMe() {
  // Вход живёт, пока жива сессия NL: вернулись на вкладку (возможно, после выхода из NL) — перепроверяем.
  return useQuery({ queryKey: AUTH_KEYS.me, queryFn: api.auth.me, retry: false, refetchOnWindowFocus: 'always' });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.auth.logout,
    onSuccess: () => qc.setQueryData(AUTH_KEYS.me, null),
  });
}

export function useDevLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: DevLoginInput) => api.auth.devLogin(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: AUTH_KEYS.me }),
  });
}
